import { EOfferType } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { IAddFavoriteResponse } from '../../repositories/favorites/v1/add-favorite';
import { selectOfferById } from '../../selectors/listingOffers';
import { fetchAddToFavorites } from '../../services/newFavorites/fetchAddToFavorites';
import { ITypedReduxAction, TThunkAction } from '../../types/redux';
import { zoomToPrecision } from '../../utils/precision';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAddToFavoritesActionTypes {
  Request = 'addToFavorites/request',
  Success = 'addToFavorites/success',
  Failure = 'addToFavorites/failure',
}

export interface IChangeFavoritePayload {
  offerId: number;
  isFavorite: boolean;
  currentPrecision: number;
  selectedFeatureId: string;
}

export type TRequestAddToFavorites = ITypedReduxAction<EAddToFavoritesActionTypes.Request>;
export type TSuccessAddToFavorites = ITypedReduxAction<EAddToFavoritesActionTypes.Success, IChangeFavoritePayload>;
export type TFailureAddToFavorites = ITypedReduxAction<EAddToFavoritesActionTypes.Failure>;

export const requestAddToFavorites: () => TRequestAddToFavorites = actionGenerator<EAddToFavoritesActionTypes.Request>(
  EAddToFavoritesActionTypes.Request,
);

export const successAddToFavorites: (payload: IChangeFavoritePayload) => TSuccessAddToFavorites = actionGenerator<
  EAddToFavoritesActionTypes.Success,
  IChangeFavoritePayload
>(EAddToFavoritesActionTypes.Success);

export const failureAddToFavorites: () => TFailureAddToFavorites = actionGenerator<EAddToFavoritesActionTypes.Failure>(
  EAddToFavoritesActionTypes.Failure,
);

export const addToFavorites =
  (offerId: number): TThunkAction<Promise<IAddFavoriteResponse>> =>
  async (dispatch, getState, context) => {
    const { config, logger } = context;
    const state = getState();
    const {
      map: {
        activeFeature: selectedFeature,
        mapBounds: { zoom: currentZoom },
      },
    } = state;
    const currentPrecision = zoomToPrecision(config, currentZoom);

    const offer = selectOfferById(state, offerId);
    const { offerType } = offer || {};
    const entityType = offerType === EOfferType.Flat ? EEntityType.OfferResidental : EEntityType.OfferSuburban;

    try {
      if (!offer) {
        logger.error('Не удалось добавить объявление в избранное', {
          domain: 'dailyrent-search-frontend/addToFavorites',
        });
        throw new Error('Объявление не найдено');
      }

      dispatch(requestAddToFavorites());

      const result = await fetchAddToFavorites(context, {
        entityId: offer.cianId,
        dealType: EDealType.Rent,
        entityType,
      });

      dispatch(
        successAddToFavorites({
          offerId,
          currentPrecision,
          isFavorite: true,
          selectedFeatureId: selectedFeature?.id || '',
        }),
      );

      return result;
    } catch (error) {
      dispatch(failureAddToFavorites());

      logger.error(error);
      throw error;
    }
  };
